import { Annotation, PlottableReference, PlottableModel, LegacyAnnotationRenderer } from '4d-mapper';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import {fas} from '@fortawesome/pro-solid-svg-icons';

const Cesium = (<any>window).Cesium

/**
 * an implmentation speicifc coordinate. Contains untis to convert from cesium to standard coords
 * as well as placeholders for holding the cesium cartesian coords so they dont need to be recalced
 */
export class PinAnnotationRenderer extends LegacyAnnotationRenderer{


  onUpdate(obj: Annotation, pr: PlottableReference, args?: any):Observable<PlottableReference> {
    return super.onUpdate(obj,pr,args).pipe(tap(res => res.object.pin.billboard.image = this.getPinImage(res.plottable)))
  }
  


   /*
        Static pin helpers 
    */

   getPinImage ( annotation: PlottableModel<any>, pinColor?: string ) {
    if (!annotation) return;
    var icon = this.getPinIcon(annotation)
    return this.getPinSvg ( icon, pinColor ? pinColor : annotation['color'] || 'blue' );
  }

  getPinSvg ( icon:string, pinColor:string = 'red', size:number = 45 ) {
    var iconZ:any = fas[icon] ||  fas[Object.keys(fas).find(k => fas[k].iconName == icon)];
    return 'data:image/svg+xml;base64,' + window['btoa'](
      '<svg aria-hidden="true" data-prefix="fas" data-icon="tags" role="img" xmlns="http://www.w3.org/2000/svg" height="'+size+'" width="'+size+'" viewBox="0 0 640 517">' +
      '<path fill="' + pinColor + '" d="' + iconZ.icon[4] + '"></path></svg>');
  }

  getPinIcon(annotation: PlottableModel<any>) {
      return Object.keys(fas).find(k => fas[k].iconName == (annotation['icon'] || 'map-marker-alt'))
  }

}
